export const getPartesFilterDay = (date = new Date()) =>
	`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

export const restoreDailyPartesFilters = (state, today = getPartesFilterDay()) => {
	if (state?.filterDay === today) return state;
	return {
		...(state || {}),
		filterDay: today,
		fechaDesde: today,
		fechaHasta: today,
		filtroAplicado: {
			...(state?.filtroAplicado || {}),
			fechaDesde: today,
			fechaHasta: today,
		},
		currentPage: 1,
	};
};
